exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row-pointer tbody tr{cursor:pointer}.header-cells{padding-top:0;padding-bottom:0}.dues-container{border-top:1px solid #000;border-left:1px solid #000}.dues-header{font-weight:700}.dues-cell{border-right:1px solid #000;border-bottom:1px solid #000;text-align:center}.totals-container{border-top:1px solid #000;border-left:1px solid #000;width:50%}.totals-cell{border-right:1px solid #000;border-bottom:1px solid #000}@media print{.pagebreak{page-break-after:always;min-height:1px}body,html{font-size:10pt;margin-top:-50px}.dues-cell,.totals-cell{padding-top:8px;padding-bottom:4px}}", ""]);

// exports
